
import mapboxgl from 'mapbox-gl';

// Set Mapbox token from environment variable
const mapboxToken: string = import.meta.env.VITE_MAPBOX_TOKEN || '';

if (mapboxToken) {
  mapboxgl.accessToken = mapboxToken;
} else {
  console.warn('VITE_MAPBOX_TOKEN is not set. Mapbox functionality will not work.');
}

export { mapboxgl };
